module.exports = __webpack_public_path__ + "static/media/bipsu.logo.160w.c83f3863.png";